import { render, staticRenderFns } from "./ActItems.vue?vue&type=template&id=2ea9b16a"
import script from "./ActItems.vue?vue&type=script&lang=js"
export * from "./ActItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports